import { NotificationState, ReduxState } from '../initialState';

export const allNotifications = (state: ReduxState): NotificationState => state.notifications;
